import styled from "styled-components";

export const ContainerCard = styled.div`
  flex: 1;
  height: calc(100vh - 4rem);
  position: relative;
  margin-left: 0;
  background: #ffffff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.01);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  overflow-y: scroll;
  max-width: 400px;
  margin: 2rem;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ContainerHeaderCard = styled.div`
  width: 100%;
  display: flex;
`;

export const AvatarProfile = styled.img`
  width: 5rem;
  height: 5rem;
  border-radius: 3rem;
`;
export const ContainerDetailProfile = styled.div`
  padding-left: 1rem;
  align-self: center;
  & > h2 {
    margin: 0;
    color: #123559;
    text-align: start;
  }
  & > p {
    margin: 0;
    color: #808080;
    text-align: start;
    font-weight: 200;
  }
`;
export const TitleDetail = styled.p`
  color: #123559;
  text-align: start;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;
export const Detail = styled.p`
  color: #808080;
  font-weight: 300;
`;

export const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  background-color: #123559;
  border: none;
  color: #fff;
  align-self: center;
`;

export const Textarea = styled.textarea`
  border-radius: 1rem;
  background-color: #f8f9fd;
  width: 100%;
  border: none;
  padding: 1rem;
  flex: 1;
  margin-bottom: 1rem;
  height: auto;
`;